'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _OrderInput = require('../OrderInput/OrderInput');

var _OrderInput2 = _interopRequireDefault(_OrderInput);

var _OrderButton = require('../OrderButton/OrderButton');

var _OrderButton2 = _interopRequireDefault(_OrderButton);

var _Sms = require('../../icons/Sms');

var _Sms2 = _interopRequireDefault(_Sms);

var _I18n = require('@wix/wixrest-utils/dist/I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _PhoneUtils = require('@wix/wixrest-utils/dist/PhoneUtils');

var _PhoneUtils2 = _interopRequireDefault(_PhoneUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('./OrderSms.less');

var _I18n$getComponentHea = _I18n2.default.getComponentHeader('openrest_checkoutordersms_'),
    I18N = _I18n$getComponentHea.I18N;

var _default = (_temp2 = _class = function (_React$Component) {
    (0, _inherits3.default)(_default, _React$Component);

    function _default() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, _default);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = _default.__proto__ || (0, _getPrototypeOf2.default)(_default)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            value: '',
            isPristine: true,
            error: false
        }, _this.onSubmit = function (e) {
            var value = _this.state.value;


            if (e && e.preventDefault) {
                e.preventDefault();
            }

            if (!_this.props.isConfirming && value) {
                _this.props.onSubmit(value);
            }
        }, _this.onCodeChange = function (value) {
            _this.setState({
                isPristine: _lodash2.default.isEmpty(value),
                value: value,
                error: false
            });
        }, _this._prepare = function (_ref2) {
            var phone = _ref2.phone,
                countryCode = _ref2.countryCode;

            var phoneDisplay = _PhoneUtils2.default.displayPhone(phone, countryCode);
            var i18nStrings = {
                title: I18N('title', 'Just One More Thing'),
                code: I18N('codeinput', 'Enter the code here'),
                error: I18N('error', 'Hmm...this code doesn’t match. Try again?'),
                button: I18N('button', 'Validate and Confirm'),
                extramessage0: I18N('extramessage0', 'Didn’t get the SMS?'),
                extramessage1: I18N('extramessage1', 'Go back and double check your phone number')
            };

            return {
                i18nStrings: i18nStrings,
                phone: phoneDisplay
            };
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(_default, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (!nextProps.isConfirming && !nextProps.isCorrect && !this.state.isPristine) {
                this.setState({ error: true }, function () {
                    _this2.refs.input.focus();
                });
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            setTimeout(function () {
                return _this3.refs.input.focus();
            }, 50);
        }
    }, {
        key: 'render',
        value: function render() {
            var error = this.state.error;
            var _props = this.props,
                styleModule = _props.styleModule,
                description = _props.description,
                extraMessage = _props.extraMessage,
                backElem = _props.backElem,
                isConfirming = _props.isConfirming,
                titleId = _props.titleId,
                descriptionId = _props.descriptionId;

            var _prepare = this._prepare(this.props),
                i18nStrings = _prepare.i18nStrings,
                phone = _prepare.phone;

            var description2 = I18N('description2', 'We sent a verification code ' + 'to ${params.phone}', { params: { phone: phone } });

            return _react2.default.createElement(
                'div',
                { className: styleModule.wrapper + ' openrest_Checkout_OrderSms_wrapper ' + (error ? 'shake' : '') },
                _react2.default.createElement(
                    'div',
                    { className: styleModule.header + ' header' },
                    _react2.default.createElement(
                        'div',
                        { className: styleModule.icon + ' icon' },
                        _react2.default.createElement(_Sms2.default, null)
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: styleModule.body + ' body' },
                    _react2.default.createElement(
                        'div',
                        { id: titleId, className: styleModule.title + ' title', 'data-hook': 'sms_title' },
                        i18nStrings.title
                    ),
                    _react2.default.createElement(
                        'div',
                        { id: descriptionId, className: styleModule.description + ' description', 'data-hook': 'sms_description' },
                        _react2.default.createElement(
                            'div',
                            null,
                            description
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            description2
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: styleModule.codeInput + ' codeinput' },
                        _react2.default.createElement(
                            'form',
                            { onSubmit: this.onSubmit },
                            _react2.default.createElement(_OrderInput2.default, {
                                ref: 'input',
                                dataHook: 'sms_input',
                                title: i18nStrings.code,
                                onChange: this.onCodeChange,
                                center: true,
                                value: this.state.value,
                                error: error,
                                select: error,
                                errorMessage: i18nStrings.error,
                                errorPosition: 'bottom' })
                        )
                    ),
                    _react2.default.createElement(
                        _OrderButton2.default,
                        {
                            type: 'primary',
                            dataHook: 'sms_confirm',
                            onClick: this.onSubmit,
                            display: 'block',
                            showSpinner: isConfirming,
                            className: styleModule.submitButton,
                            spinnerClass: styleModule.submitButtonSpinner,
                            width: 252 },
                        i18nStrings.button
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: styleModule.extraMessage + ' extramessage', 'data-hook': 'sms_footer' },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    i18nStrings.extramessage0
                                ),
                                ' ',
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    i18nStrings.extramessage1
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                extraMessage
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            backElem
                        )
                    )
                )
            );
        }
    }]);
    return _default;
}(_react2.default.Component), _class.displayName = 'OrderSms', _class.propTypes = {
    phone: _propTypes2.default.string,
    countryCode: _propTypes2.default.string,
    isConfirming: _propTypes2.default.bool,
    isCorrect: _propTypes2.default.bool,
    description: _propTypes2.default.string,
    extraMessage: _propTypes2.default.string,
    backElem: _propTypes2.default.node,
    styleModule: _propTypes2.default.object,
    onSubmit: _propTypes2.default.func.isRequired,
    titleId: _propTypes2.default.string,
    descriptionId: _propTypes2.default.string
}, _class.defaultProps = {
    extraMessage: '',
    titleId: '',
    descriptionId: ''
}, _temp2);

exports.default = _default;